import styled from "styled-components";
import Variables from "../../../assets/styleVariables";

export const SettingContainer = styled.div`
  position: relative;
`;